<template>
  <div
    class="schedulePlayers_match_list"
    :class="themeClass === 'onlyDisplay' ? 'onlyDisplay' : ''"
  >
    <div
      class="match_list_item"
      :class="[chooseState, item.isChooseFlag ? 'chooseAct' : '']"
      v-for="item in data"
      :key="item.matchId"
      @click="goDetail(item)"
    >
      <span class="item_matchLeft">
        <span class="matchLeft_colum1">
          <span
            v-if="themeClass === 'onlyDisplay'"
            class="matchLeft_colum1_row1"
            :datas="JSON.stringify(item)"
            v-text="
              _valPerFormatHandler(
                `${item.formatDate ? item.formatDate : ''} ${item.matchTime}`
              )
            "
          ></span>
          <span
            v-else
            class="matchLeft_colum1_row1"
            v-text="_valPerFormatHandler(item.matchTime)"
          ></span>
          <!-- <span class="matchLeft_colum1_row2">
            <span class="national_icon" v-if="item.isChina"></span>
            <span class="medal_icon" v-if="item.isGold"></span>
          </span> -->
        </span>
        <span class="matchLeft_colum2">
          <span
            class="matchLeft_colum2_row1"
            v-text="_valPerFormatHandler(item.matchName)"
          ></span>
          <!-- <span class="matchLeft_colum2_row2">
            <span class="playerList_icon">
              <svg
                t="1694694785013"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="15684"
                width="100%"
                height="100%"
              >
                <path
                  d="M779.706 135c54.962 0 99.51 45.152 99.51 100.848v611.397c0 55.666-44.548 100.853-99.51 100.853H271.51c-54.961 0-99.509-45.187-99.509-100.853V235.848C172 180.152 216.548 135 271.509 135h508.197zM656.142 658.593C666.934 656.5 675.387 645.475 672 635c-28.95-89.539-35.905-104.631-115.242-123.59 43.078-18.904 73.322-62.315 73.322-112.781 0-67.776-54.386-122.912-121.293-122.912-66.908 0-121.294 55.136-121.294 122.912 0 50.466 30.245 93.877 73.293 112.78-79.077 18.899-142.528 82.687-158.356 166.202-2.071 10.957 5.007 21.562 15.8 23.627 10.815 2.095 21.203-5.078 23.308-16.006 15.337-81.036 85.668-139.77 167.19-139.77C590.568 545.461 622 585 632.89 642.5c1.833 9.675 10.158 16.42 19.542 16.42 1.205 0 2.445-0.12 3.709-0.328zM590.283 398.63c0 45.505-36.575 82.54-81.496 82.54-44.918 0-81.497-37.035-81.497-82.54 0-45.51 36.579-82.545 81.497-82.545 44.921 0 81.496 37.034 81.496 82.545zM597 635h150c13.807 0 25 11.193 25 25s-11.193 25-25 25H597c-13.807 0-25-11.193-25-25s11.193-25 25-25z m0 100h150c13.807 0 25 11.193 25 25s-11.193 25-25 25H597c-13.807 0-25-11.193-25-25s11.193-25 25-25z"
                  p-id="15685"
                ></path>
              </svg>
            </span>
            <span
              class="sportHall_name"
              v-text="_valPerFormatHandler(item.playeStringName)"
            ></span>
          </span> -->
        </span>
      </span>
      <span class="item_absChoose" v-show="chooseState === 'choose'">
        <span class="checkbox_item">
          <svg
            t="1693726421166"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="21127"
            width="80%"
            height="80%"
          >
            <path
              d="M892.064 261.888a31.936 31.936 0 0 0-45.216 1.472L421.664 717.248l-220.448-185.216a32 32 0 1 0-41.152 48.992l243.648 204.704a31.872 31.872 0 0 0 20.576 7.488 31.808 31.808 0 0 0 23.36-10.112L893.536 307.136a32 32 0 0 0-1.472-45.248z"
              p-id="21128"
            ></path>
          </svg>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'schedulePlayers_match_list',
  mixins: [cup_base_data_mixin],
  props: {
    data: {
      type: Array,
      default: () => {
        return []
        // return [
        //   {
        //     matchId: 1,
        //     matchName: '篮球·男子预赛A组',
        //     type: 'combat', //对抗类或非对抗类
        //     isChina: true,
        //     isGold: false,
        //     medalist: [
        //       {
        //         playerId: '1',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //       {
        //         playerId: '2',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //       {
        //         playerId: '3',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //     ],
        //     disciplineName: '艺术体操',
        //     disciplineId: 'GRY',
        //     matchStatus: 'Playing',
        //     matchTime: '12:30',
        //     playeStringName: '场馆名称场馆名称1',
        //     homeName: '主队',
        //     homeLogo: '',
        //     homeScore: 3,
        //     awayName: '客队',
        //     awayLogo: '',
        //     awayScore: 2,
        //   },
        //   {
        //     matchId: 2,
        //     matchName:
        //       '篮球·男子预赛A组篮球·男子预赛A组篮球·男子预赛A组篮球·男子预赛A组',
        //     type: 'uncombat', //对抗类或非对抗类
        //     isChina: true,
        //     isGold: true,
        //     medalist: [
        //       {
        //         playerId: '1',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //       {
        //         playerId: '2',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //       {
        //         playerId: '3',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //     ],
        //     disciplineName: '艺术体操',
        //     disciplineId: 'GRY',
        //     matchStatus: 'Played',
        //     matchTime: '12:30',
        //     playeStringName: '场馆名称场馆名称1',
        //     homeName: '主队',
        //     homeLogo: '',
        //     homeScore: 3,
        //     awayName: '客队',
        //     awayLogo: '',
        //     awayScore: 2,
        //   },
        //   {
        //     matchId: 3,
        //     matchName:
        //       '篮球·男子预赛A组篮球·男子预赛A组篮球·男子预赛A组篮球·男子预赛A组',
        //     type: 'uncombat', //对抗类或非对抗类
        //     isChina: true,
        //     isGold: true,
        //     medalist: [
        //       {
        //         playerId: '1',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //       {
        //         playerId: '2',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //       {
        //         playerId: '3',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //     ],
        //     disciplineName: '艺术体操',
        //     disciplineId: 'GRY',
        //     matchStatus: 'Played',
        //     matchTime: '12:30',
        //     playeStringName: '场馆名称场馆名称1',
        //     homeName: '主队',
        //     homeLogo: '',
        //     homeScore: 3,
        //     awayName: '客队',
        //     awayLogo: '',
        //     awayScore: 2,
        //   },
        //   {
        //     matchId: 4,
        //     matchName:
        //       '篮球·男子预赛A组篮球·男子预赛A组篮球·男子预赛A组篮球·男子预赛A组',
        //     type: 'uncombat', //对抗类或非对抗类
        //     isChina: true,
        //     isGold: true,
        //     medalist: [
        //       {
        //         playerId: '1',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //       {
        //         playerId: '2',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //       {
        //         playerId: '3',
        //         playerName: '张三',
        //         medalType: 'GOLD',
        //         delegationName: '中国',
        //         delegationLogo: '',
        //       },
        //     ],
        //     disciplineName: '艺术体操',
        //     disciplineId: 'GRY',
        //     matchStatus: 'Played',
        //     matchTime: '12:30',
        //     playeStringName: '场馆名称场馆名称1',
        //     homeName: '主队',
        //     homeLogo: '',
        //     homeScore: 3,
        //     awayName: '客队',
        //     awayLogo: '',
        //     awayScore: 2,
        //   },
        // ]
      },
    },
    detailPathName: {
      type: String,
      default: '',
    },
    chooseState: {
      type: String,
      default: 'default', //['default', 'choose', 'none'] none：没有鼠标经过效果
    },
    localStorageName: {
      type: String,
      default: '',
    },
    localStorageSaveDate: {
      // 该字段在运动员赛程中有
      type: String,
      default: '',
    },
    themeClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      sportsTypeArr: ['combat', 'uncombat'],
      matchStatusObj: {
        CANCELLED: 3,
        DELAYED: 3,
        FINISHED: 2,
        GETTING_READY: 0,
        INTERRUPTED: 3,
        POSTPONED: 3,
        RESCHEDULED: 3,
        RUNNING: 1,
        SCHEDULED: 0,
        SCHEDULED_BREAK: 1,
        UNSCHEDULED: 2,
      },
      matchStatusColorArr: [
        {
          colorClass: 'unstart',
          key: ['GETTING_READY', 'SCHEDULED'],
          name: ['已就绪', '按日程计划'],
        },
        {
          colorClass: 'playing',
          key: ['RUNNING', 'SCHEDULED_BREAK'],
          name: ['比赛中', '中场休息'],
        },
        {
          colorClass: 'finished',
          key: ['FINISHED', 'UNSCHEDULED'],
          name: ['已结束', '未安排'],
        },
        {
          colorClass: 'other',
          key: ['CANCELLED', 'DELAYED', 'INTERRUPTED', 'RESCHEDULED'],
          name: ['已取消', '延误', '中断', '推迟', '改期'],
        },
      ],
    }
    // CANCELLED 已取消
    // DELAYED 延误
    // FINISHED 已结束
    // GETTING_READY 已就绪
    // INTERRUPTED 中断
    // POSTPONED 推迟
    // RESCHEDULED 改期
    // RUNNING 比赛中
    // SCHEDULED 按日程计划
    // SCHEDULED_BREAK 中场休息
    // UNSCHEDULED 未安排
  },
  methods: {
    // matchStatusToMatchCN(matchStatus) {
    //   let index = this.matchStatusObj[matchStatus]
    //   let item = this.matchStatusColorArr[index]
    //   let matchCN = item.name[item.key.indexOf(matchStatus)]
    //   return this._valPerFormatHandler(matchCN)
    // },
    goDetail(item) {
      console.debug(item)
      if (this.chooseState === 'choose' && this.localStorageName) {
        let chooseObj = this.$localStorage.getItem(this.localStorageName)
          ? JSON.parse(this.$localStorage.getItem(this.localStorageName))
          : {
              cid: this.currCid,
              // date: this.localStorageSaveDate,
              chooseItemArr: [],
              chooseIdArr: [],
            }
        if (chooseObj.cid === this.currCid) {
          if (chooseObj.chooseItemArr.length === 0) {
            let newItem = JSON.parse(JSON.stringify(item))
            newItem.isChooseFlag = true
            newItem.dateYMD = this.localStorageSaveDate
            chooseObj.chooseItemArr.push(newItem)
            chooseObj.chooseIdArr.push(item.chooseId)
          } else {
            let chooseItemArr = []
            let chooseIdArr = []
            chooseObj.chooseItemArr.forEach((chooseItem, chooseItemIndex) => {
              if (chooseItem.chooseId !== item.chooseId) {
                chooseItemArr.push(chooseItem)
                chooseIdArr.push(chooseItem.chooseId)
              }
            })
            if (chooseItemArr.length === chooseObj.chooseItemArr.length) {
              let newItem = JSON.parse(JSON.stringify(item))
              newItem.isChooseFlag = true
              newItem.dateYMD = this.localStorageSaveDate
              chooseItemArr.push(newItem)
              chooseIdArr.push(item.chooseId)
            }
            chooseObj.chooseItemArr = chooseItemArr
            chooseObj.chooseIdArr = chooseIdArr
          }
          this.$localStorage.setItem(
            this.localStorageName,
            JSON.stringify(chooseObj)
          )
          this.$emit('changeChooseNumEvent', {
            localStorageName: this.localStorageName,
            val: chooseObj.chooseIdArr.length,
            init: false,
          })
          console.debug('chooseObj:', chooseObj)
        } else {
          console.error('错误：赛事不同')
        }
      } else if (this.detailPathName) {
        let currSportsDetail = {
          sportsId: item.sportsId,
          eventId: item.eventId,
          matchId: item.matchId,
          sportsName: item.sportsName,
          eventName: item.eventName,
          // matchDetail: item
        }
        console.debug('sportsDetail_compreScore:', currSportsDetail)
        this.$localStorage.setItem(
          'mixtmt_platfromV4_currSportsDetail',
          JSON.stringify(currSportsDetail)
        )
        let params = {
          cid: this.currCid,
          sid: this.currSid,
          sportsId: item.sportsId,
          eventId: item.eventId,
          mid: item.matchId,
        }
        this.openNewWeb(
          this.$router,
          `${this.detailPathName}_${this.currCid}`,
          params
        )
      }
    },
    _valPerFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.mixtmt_pc,
.mixtmt_ipad {
  .schedulePlayers_match_list {
    width: 100%;
    height: auto;
    &.onlyDisplay .match_list_item {
      .item_matchLeft {
        .matchLeft_colum1 {
          width: 16.8vw;
        }
        .matchLeft_colum2 {
          width: calc(100% - 16.8vw);
        }
      }
    }
    .match_list_item {
      position: relative;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: flex-start;
      height: auto;
      width: 100%;
      padding: 1.11vw 1.388vw;
      color: var(--mixtmt_greyColor3);
      border-bottom: 1px solid var(--mixtmt_greyColor5);
      transition: padding 0.3s linear;
      &.choose {
        padding: 1.11vw 1.388vw 1.11vw 3.2vw;
        .item_absChoose {
          width: 3.2vw;
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          .checkbox_item {
            width: 1.388vw;
            height: 1.388vw;
            border-radius: 0.208vw;
            border: 1px solid var(--mixtmt_subColor1_1);
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: center;
            background-color: var(--mixtmt_whiteColor);
            /* &.act {
                      background-color: var(--mixtmt_subColor1_1);
                      color: var(--mixtmt_whiteColor);
                    } */
            svg {
              opacity: 0;
              fill: var(--mixtmt_whiteColor);
              transition: all 0.3s linear;
            }
          }
        }
        &.chooseAct {
          .checkbox_item {
            background-color: var(--mixtmt_subColor1_1);
            svg {
              opacity: 1;
            }
          }
        }
      }
      .matchLeft_colum1,
      .matchLeft_colum2,
      .matchCenter_colum1,
      .matchCenter_colum2 {
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        align-items: flex-start;
        flex-direction: column;
        height: auto;
      }
      .matchLeft_colum1_row1,
      .matchLeft_colum2_row1,
      .matchCenter_colum1_row,
      .matchCenter_colum2_row {
        /* margin-bottom: 0.347vw; */
      }
      .item_matchLeft {
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        .matchLeft_colum1 {
          width: 16.8vw;
          .matchLeft_colum1_row1 {
            width: 100%;
            font-size: 1.388vw;
            line-height: 2.083vw;
            height: 2.083vw;
            font-weight: bold;
          }
          .matchLeft_colum1_row2 {
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: center;
            width: 100%;
            height: 2.083vw;
            .national_icon {
              padding-right: 0.694vw;
              width: 2.083vw;
              height: 0.903vw;
              overflow: hidden;
              background-image: var(--mixtmt_china_square_icon);
              background-size: auto 100%;
              background-repeat: no-repeat;
              background-position: left center;
            }
            .medal_icon {
              padding-right: 0.694vw;
              width: 1.805vw;
              height: 1.11vw;
              overflow: hidden;
              background-image: var(--mixtmt_medal_gold_icon);
              background-size: auto 100%;
              background-repeat: no-repeat;
              background-position: left center;
            }
          }
        }
        .matchLeft_colum2 {
          width: calc(100% - 16.8vw);
          .matchLeft_colum2_row1 {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 1.38vw;
            line-height: 2.083vw;
            height: 2.083vw;
            font-weight: bold;
          }
          .matchLeft_colum2_row2 {
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: center;
            width: 100%;
            height: 2.083vw;
            .playerList_icon {
              width: 2.083vw;
              height: 2.083vw;
              /* background-image: var(--mixtmt_scheduleMatchList_playerList_icon);
                background-size: 100% auto;
                background-position: 0 0;
                background-repeat: no-repeat; */
              svg {
                fill: var(--mixtmt_mainColor);
              }
            }
            .sportHall_name {
              width: calc(100% - 2.083vw);
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 1.11vw;
              line-height: 2.083vw;
              padding: 0 0.486vw;
              color: var(--mixtmt_greyColor2);
            }
          }
        }
      }
      .item_absChoose {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        width: 0;
        height: 100%;
        transition: width 0.3s linear;
      }
    }
  }
}

.mixtmt_pc {
  .schedulePlayers_match_list {
    .match_list_item:not(.none) {
      &:hover,
      &.choose.chooseAct {
        background-color: var(--mixtmt_mainColor);
        color: var(--mixtmt_whiteColor);

        .item_matchLeft {
          .matchLeft_colum2 {
            .matchLeft_colum2_row2 {
              svg {
                fill: var(--mixtmt_whiteColor);
              }
              .sportHall_name {
                color: var(--mixtmt_whiteColor);
              }
            }
          }
        }
      }
      &.choose {
        cursor: pointer;
      }
    }
  }
}
</style>
